import type {SlotGameStore, BaseComponentConfig} from "@gamzix/slot_core";

class IntrigueComponent extends Game.src.component.BaseComponent {
    protected mainGameContainerElement = null;
    protected bonusGameContainerElement = null;
    protected reelFrameWrapperContainerElement = null;
    protected reelsMap = null;
    protected reelId = null;
    protected SYMBOLS_HEIGHT = 247;
    protected intrigeLevelSpeedMain = 1;

    protected bonusGlowList = {};

    static events = {
        REEL_START: 'Intrigue.REEL_START',
        REEL_FINISH: 'Intrigue.REEL_FINISH',
        REEL_SYMBOL_START: 'Intrigue.REEL_SYMBOL_START',
        REEL_SYMBOL_FINISH: 'Intrigue.REEL_SYMBOL_FINISH',
    }

    constructor(config: BaseComponentConfig) {
        super(config);
    }

    onGameReady() {
        super.onGameReady();

        this.mainGameContainerElement = game.tree.findByName(
            "intrigue.wrapper_container.main_game_container"
        );
        this.bonusGameContainerElement = game.tree.findByName(
            "intrigue.wrapper_container.bonus_game_container"
        );
        this.reelFrameWrapperContainerElement = game.tree.findByName(
            "reel_frame.wrapper_container"
        );

        this.reelsMap = this.createReelsMapObj();

        game.on(ReelsetComponent.events.REEL_ANTICIPATION_STARTED, ({reelId}) => {
            if(this.store.gameData.bonusGame.isPlaying()) return;

            this.reelId = reelId;

            this.showReelIntrigue(reelId);
        });

        game.on(ReelsetComponent.events.REEL_ANTICIPATION_FINISHED, ({reelId}) => {
            if(this.store.gameData.bonusGame.isPlaying()) return;

            this.hideReelIntrigue(reelId);

            this.handleLevelUpMain();
        });
    }

    getFSMHandlers() {
        return {
            SPIN: {
                exit: {
                    on: () => {
                        this.resetSpeeds();
                    }
                }
            }
        };
    }

    showReelIntrigue(reelId) {
        console.log("***this.intrigeLevelSpeedMain: ", this.intrigeLevelSpeedMain);
        game.emit(IntrigueComponent.events.REEL_START, {reelId: reelId, speed: this.intrigeLevelSpeedMain});
        this.setPositionMainGlow(reelId);
        this.showFlowMainGame();
    }

    hideReelIntrigue(reelId) {
        game.emit(IntrigueComponent.events.REEL_FINISH, {reelId: reelId, speed: this.intrigeLevelSpeedMain});

        this.hideFlowMainGame();
        this.onChangeOrientation();
    }

    protected async showFlowMainGame() {
        await game.utils.GameUtils.playAlphaAnimation(this.mainGameContainerElement, {from: 0, to: 1, time: 300, timeWait: 0});

        this.onChangeOrientation();
    }

    protected async hideFlowMainGame() {
        await game.utils.GameUtils.playAlphaAnimation(this.mainGameContainerElement, {from: 1, to: 0, time: 300, timeWait: 0});

        this.onChangeOrientation();
    }

    protected setPositionMainGlow(reelId) {
        this.mainGameContainerElement.options.position.x =
            this.reelsMap[`reel_${reelId}`].position.x;
    }

    async playAlphaAnimation(object, {from, to, time, timeWait}): Promise<void> {
        return new Promise((resolve) => {
            const _tw = {count: from};

            object.options.visible = true;
            object.options.alpha = from;

            const _tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    object.options.alpha = _tw.count;
                    object.updateViewOptions();
                }
            })
                .to({count: to}, time)
                .wait(timeWait || 0)
                .call(() => {
                    object.options.visible = Boolean(to);
                    resolve();
                });

            object._tween = _tween;
        });
    }


    getSymbolIntriguePosition(reelId, symbolIndex) {
        return {x: this.reelsMap[`reel_${reelId}`].position.x, y: 30 + this.SYMBOLS_HEIGHT * (symbolIndex - 1)}
    }

    createReelsMapObj() {
        return {
            reel_0: game.tree.findByName("reel_0"),
            reel_1: game.tree.findByName("reel_1"),
            reel_2: game.tree.findByName("reel_2"),
            reel_3: game.tree.findByName("reel_3"),
            reel_4: game.tree.findByName("reel_4"),
        };
    }

    handleLevelUpMain() {
        if (this.intrigeLevelSpeedMain !== 4) {
            this.intrigeLevelSpeedMain++
        }
    }

    resetSpeeds() {
        this.intrigeLevelSpeedMain = 1;
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
}

export {IntrigueComponent};

//@ts-ignore
Game.src.component.IntrigueComponent = IntrigueComponent;
